import { render, staticRenderFns } from "./ScrollerPartial.vue?vue&type=template&id=22fec074&scoped=true&"
import script from "./ScrollerPartial.vue?vue&type=script&lang=js&"
export * from "./ScrollerPartial.vue?vue&type=script&lang=js&"
import style0 from "./ScrollerPartial.vue?vue&type=style&index=0&id=22fec074&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fec074",
  null
  
)

export default component.exports